import React from 'react'
import { useTheme } from '@mui/material'
import { IconProps } from '@f-fertighaus/applications/Next/types/icon'

export const LeafBigIcon = (props: IconProps) => {
  const theme = useTheme()
  const stroke = props.color || theme.palette.primary.main
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.25 4.28882C12.8251 3.92153 13.4267 3.59763 14.05 3.31982C14.05 3.31982 15.7642 7.38607 14.5882 10.2763C13.8447 12.1028 12.22 13.1941 10.75 12.9713'
        stroke={stroke}
        strokeLinecap='square'
      />
      <path
        d='M3.75001 4.2887C3.17493 3.92141 2.57326 3.59751 1.95001 3.3197C1.95001 3.3197 0.236255 7.38595 1.41226 10.2762C2.15526 12.1027 3.78001 13.194 5.25001 12.9712'
        stroke={stroke}
        strokeLinecap='square'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.5 8C4.5 4.5 8 0.75 8 0.75C8 0.75 11.5 4.5 11.5 8C11.5 10.5 9.933 12.5 8 12.5C6.067 12.5 4.5 10.5 4.5 8Z'
        stroke={stroke}
        strokeLinecap='square'
      />
      <path d='M8 15.5V5.75' stroke={stroke} strokeLinecap='square' />
      <path d='M8.25 10.25L10 8.75' />
      <path d='M7.75 8.75L6 7.25' />
    </svg>
  )
}
